<template>
  <d-form-row>
    <d-col cols="12" class="d-flex flex-column mt-2">
      <d-button
        @click.prevent="generatePDF('questions')"
        class="btn-dark btn-outline-black"
      >
        {{ $t('cryptogramGenerator.button.printGame') }}
      </d-button>
      <d-button
        @click.prevent="generatePDF('answers')"
        class="btn-outline-black btn-block mt-2"
      >
        {{ $t('cryptogramGenerator.button.printAnswers') }}
      </d-button>
    </d-col>
  </d-form-row>
</template>

<script>
import pdfService from '_services/rest/modules/pdfService';
import html2pdf from 'html2pdf.js';
import { mapActions } from 'vuex';

export default {
  name: 'print-buttons',
  props: {
    cryptogramName: {
      type: String,
      require: true,
    },
  },
  data() {
    return {
      printQuestion: false,
    };
  },
  methods: {
    ...mapActions(['setToggle']),
    getClonePuzzleToPrint() {
      const element = document.getElementById('print');

      const clonedElement = element.cloneNode(true);
      clonedElement.style.transform = 'scale(0.7)';
      clonedElement.style.transformOrigin = 'top left';

      const elementsToExcludeClone =
        clonedElement.querySelectorAll('.no-print');

      if (!this.printQuestion) {
        const elementsPrintClone = clonedElement.querySelectorAll('.symbol');

        elementsPrintClone.forEach(el => {
          el.style.display = 'none';
        });
      }

      elementsToExcludeClone.forEach(el => {
        el.style.display = 'none';
      });

      const elementsPrintClone =
        clonedElement.querySelectorAll('.printElement');

      elementsPrintClone.forEach(el => {
        if (this.printQuestion) {
          const pElement = el.querySelector('p');
          if (pElement) {
            pElement.textContent = '';
          }
        }
        el.style.display = 'flex';
        el.style.alignItems = 'center';
        el.style.justifyContent = 'center';
      });

      return clonedElement;
    },
    getOptionsToPrint(puzzle) {
      const width = puzzle.offsetWidth;

      const orientation = width > 1050 ? 'landscape' : 'portrait';
      return {
        filename: 'criptograma.pdf',
        jsPDF: {
          unit: 'mm',
          format: 'a4',
          orientation,
        },
        html2canvas: {
          scale: 2,
        },
        margin: 10,
      };
    },
    async printPdf(puzzleElement) {
      const options = this.getOptionsToPrint(puzzleElement);

      await html2pdf()
        .set(options)
        .from(puzzleElement)
        .outputPdf('blob')
        .then(pdfBlob => {
          this.sendPdfToServer(pdfBlob);
        });
    },
    sendPdfToServer(pdfBlob) {
      pdfService.convertPdfToCmyk(pdfBlob);
    },
    generatePDF(type) {
      this.setToggle({ type: 'progress', bool: true });

      if (type === 'questions') this.printQuestion = true;

      const puzzleElement = this.getClonePuzzleToPrint();

      this.printPdf(puzzleElement).finally(() => {
        puzzleElement.remove();
        this.printQuestion = false;
        this.setToggle({ type: 'progress', bool: false });
      });
    },
  },
};
</script>
